import React, { ReactElement } from "react";
import { FaTree, FaTools, FaSnowflake, FaBroom } from "react-icons/fa";
import "./Services.css";

interface Service {
  icon: ReactElement;
  title: string;
  description: string;
}

const Services: React.FC = () => {
  const services: Service[] = [
    {
      icon: <FaTree />,
      title: "Gartengestaltung",
      description:
        "Professionelle Planung und Gestaltung Ihrer Gartenanlage, von der Konzeption bis zur Umsetzung.",
    },
    {
      icon: <FaTools />,
      title: "Gartenpflege",
      description:
        "Regelmäßige Pflege und Wartung Ihrer Grünanlagen, einschließlich Rasenpflege und Heckenschnitt.",
    },
    {
      icon: <FaSnowflake />,
      title: "Winterdienst",
      description:
        "Zuverlässiger Winterdienst mit Schneeräumung und Streudienst für private und gewerbliche Kunden.",
    },
    {
      icon: <FaBroom />,
      title: "Hausmeisterservice",
      description:
        "Umfassende Betreuung Ihrer Immobilie mit allen anfallenden Wartungs- und Reinigungsarbeiten.",
    },
  ];

  return (
    <section className="services">
      <div className="services-container">
        <h2>Unsere Leistungen</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
